// extracted by mini-css-extract-plugin
export default {"textContainerMain":"textContainer_textContainerMain__CN637","textValue":"textContainer_textValue__ZwUfn"};